exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "table {\n  width: 100%; }\n  table td {\n    width: 25%; }\n  table td a:after {\n      content: \"\";\n      display: inline-block;\n      width: 0.2em;\n      height: 0.2em;\n      background-color: #333;\n      border-radius: 50%;\n      margin: 0.25em;\n      margin-left: 0.4em; }\n  table td a:last-child:after {\n      display: none; }\n  table td:nth-child(2) {\n    text-align: center; }\n  table td:last-child {\n    text-align: right; }\n  .copyright {\n  font-size: 11px; }\n  @media (max-width: 721px) {\n  td {\n    width: 100%;\n    display: block;\n    margin: 0 auto; } }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/leonhard/Projekte/braungardt/angular/src/app/footer/footer.component.scss
// module id = ../../../../../src/app/footer/footer.component.scss
// module chunks = main